import i18n, { InitOptions } from 'i18next';
import each from 'lodash/each';
import get from 'lodash/get';

import preloaded from '~/preloaded';

type TranslationValue = string | string[];
type I18nCatalog = Record<string, TranslationValue>;
type I18nextTranslations = Record<string, string>;

const language = preloaded.settings.languageCode;
const catalog: I18nCatalog = get(window, 'i18n.catalog', {});

const i18nextTranslations: I18nextTranslations = {};

each(catalog, (translations: TranslationValue, key: string) => {
  if (Array.isArray(translations)) {
    i18nextTranslations[key] = translations[0];
    i18nextTranslations[`${key}_0`] = translations[0];
    i18nextTranslations[`${key}_1`] = translations[1];
    i18nextTranslations[`${key}_2`] = translations[2];
  } else {
    i18nextTranslations[key] = translations;
  }
});

const i18nextResources = {
  [language]: {
    mk: i18nextTranslations,
  },
};

const i18nConfig: InitOptions = {
  lng: language,
  resources: i18nextResources,
  ns: ['mk'],
  defaultNS: 'mk',

  nsSeparator: false,
  keySeparator: false,

  interpolation: {
    prefix: '{{',
    suffix: '}}',
    escapeValue: false,
    format: (value) => {
      return value.toString().replace(/NBSP/g, '\u00A0');
    },
  },

  pluralSeparator: '_',
  compatibilityJSON: 'v3' as const,
  debug: false,
  fallbackLng: false,
  lowerCaseLng: true,
};

i18n.init(i18nConfig);

export default i18n;
